module.exports = __webpack_public_path__ + "static/media/Easy-tab7.ee9be939.png";